/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Success_DescInputs */

const es_toast_success_desc = /** @type {(inputs: Toast_Success_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La operación fue exitosa`)
};

const en_toast_success_desc = /** @type {(inputs: Toast_Success_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The operation was successful`)
};

/**
* | output |
* | --- |
* | "The operation was successful" |
*
* @param {Toast_Success_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const toast_success_desc = /** @type {((inputs?: Toast_Success_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Success_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_toast_success_desc(inputs)
	return en_toast_success_desc(inputs)
});
export { toast_success_desc as "toast.success_desc" }